import React from 'react'

import { useToast } from '@vallourec-ui/vallourec-ui'

import { useTranslation } from 'react-i18next'

import ImageCard from '@/components/ImageCard'
import UploadBox from '@/components/UploadBox'

interface AttachmentProps {
  id?: number
  idUser?: number
  path: string
  file?: string | undefined
  extension?: string | undefined
  name: string
  size?: string | undefined
  progress?: number
}
const DEFAULT_UPLOAD_FILE_TYPES: { [key: string]: string[] } = {
  'application/vnd.ms-excel': ['.xls', '.xlsx'],
  'text/csv': ['.csv'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
}

const UploadPreview: React.FC<{
  uploadText: string
  dragAndDropText: string
  rulesText: string
  item: AttachmentProps
  acceptedTypes: typeof DEFAULT_UPLOAD_FILE_TYPES
  setData: (file: File | File[], index: number | undefined) => Promise<void>
  onDownload: () => Promise<void>
  onDelete: () => void
  index: number
}> = ({
  uploadText,
  dragAndDropText,
  rulesText,
  item,
  acceptedTypes,
  setData,
  onDownload,
  onDelete,
  index,
}) => {
  const { toast } = useToast()
  const { t } = useTranslation()
  const toastFileSizeError = () => {
    toast({
      title: t<string>('warning'),
      description: t<string>('newAnalysis.attachments.maximumFileSizeError'),
      type: 'warn',
    })
  }

  return item.file ? (
    <ImageCard
      key="image-card"
      file={item.file ?? ''}
      index={index}
      onDownload={onDownload}
      onDelete={onDelete}
    />
  ) : (
    <UploadBox
      key="upload-box"
      uploadText={uploadText}
      dragAndDropText={dragAndDropText}
      rulesText={rulesText}
      fileTypes={acceptedTypes}
      setData={setData}
      hasPreview
      height="5rem"
      index={index}
      setFileRejection={toastFileSizeError}
    />
  )
}

export default UploadPreview
